import type { FC, ReactElement } from "react"

import { useCSSInsertion } from "@/3514/hooks"

/**
 * @deprecated legacy typing animation
 */
const WaveLoader: FC = (): ReactElement => {
    useCSSInsertion({
        cssString: `
            .wave-loader {
              display: flex;
              align-items: center;
              width: 40px;
              padding: 10px 0;
              justify-content: center;
              background-color: rgb(236 236 236);
              border-radius: 50px;
            }
            .dot {
              width: 5px;
              height: 5px;
              margin: 0 2px;
              border-radius: 50%;
              background-color: rgb(174 176 178);
              animation: wave-animation 1.1s infinite ease-in-out;
            }
            .dot:nth-child(1) {
              animation-delay: -0.3s;
            }
            .dot:nth-child(2) {
              animation-delay: -0.15s;
            }
            .dot:nth-child(3) {
              animation-delay: 0s;
            }
            @keyframes wave-animation {
              0%,
              60%,
              100% {
                transform: scale(1);
                background-color: rgb(174 176 178);
              }
              30% {
                transform: scale(1.2);
                background-color: rgb(108 110 114);
              }
            }
    `
    })

    return (
        <div className="wave-loader">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
        </div>
    )
}

export default WaveLoader
